import {ref} from "vue";

// Every speaker's latest year and talk videos (newest first): fullstack's
// /sitemaps/videos/speakers.json, built with the video data (scripts/update/videos/speakerIndex.js).
// Keyed by the name without accents, lower case, as names are written both ways.
const index = ref(null); // shared: fetched once per page load
let isLoadStarted = false;

export function getSpeakerKey(name) {
  return String(name).normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase();
}

// "A & B: Title" → the speakers' keys ([] for videos not named after people)
export function getVideoSpeakerKeys(videoName) {
  const [speakerPart, ...titleParts] = String(videoName || "").split(": ");
  if (!titleParts.length) return [];
  return speakerPart.split(" & ").map(getSpeakerKey);
}

async function fetchSpeakerIndex() {
  try {
    const response = await fetch("/sitemaps/videos/speakers.json");
    index.value = response.ok ? await response.json() : {};
  } catch (error) {
    console.error(`useSpeakerIndex: ${error}`);
    index.value = {}; // loaded, empty: callers fall back rather than wait
  }
}

// {name, latestYear, videos: [{year, title, hash}]}, or null
export default function useSpeakerIndex() {
  if (!isLoadStarted) {
    isLoadStarted = true;
    fetchSpeakerIndex();
  }
  const getSpeaker = (name) => index.value?.[getSpeakerKey(name)] || null;
  return {index, getSpeaker};
}
